import React, { useEffect, useState } from 'react';
import { Box, Typography } from '@mui/material';
import { Show, useShowContext } from 'framework/show';
import useCareerReviewService from 'domain/people/employee/CareerCapabilities/qualification/Show/careerReviewService';
import { ShowDate } from 'framework/ui/ui-builder';
import { DATE_FORMAT } from 'framework/utils';
import ProcessTimelineComponent from '../../shared/ProcessTimelineComponent';
import { useProcesses } from '../../shared/ProcessesContext';

type CareerReviewData = {
  nextReviewDate: string | null;
  careerDevelopmentEvaluationMode: string | null;
};

const NextCareerReviewView: React.FC = () => {
  const { data: employeeData } = useShowContext();
  const { getCareerReviewData } = useCareerReviewService();
  const { careerProcesses, loading: processesLoading, error: processesError } = useProcesses();
  const [value, setValue] = useState<string | null>(null);

  const { alias } = employeeData.getData() || {};

  useEffect(() => {
    if (alias) {
      getCareerReviewData(alias).then((res: CareerReviewData) => {
        setValue(res.nextReviewDate);
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [alias]);

  if (!alias) {
    return null;
  }

  if (!!careerProcesses.length || processesLoading) {
    return (
      <ProcessTimelineComponent
        processes={careerProcesses}
        loading={processesLoading}
        error={processesError}
        title="Career review"
        showProcessTitle={false}
      />
    );
  }

  return (
    <Box position="relative">
      <Show getDataMethod={() => getCareerReviewData(alias)} isSmallLoader>
        <Box display="flex" mb="9px">
          <Typography flexShrink={0} mr={0.5} color="primary">
            Next career review
          </Typography>

          {value ? (
            <Typography>
              on <ShowDate dateUTC={value} format={DATE_FORMAT.NATURAL} isDateTime={false} />
            </Typography>
          ) : (
            <span>Not defined</span>
          )}
        </Box>
      </Show>
    </Box>
  );
};

export default NextCareerReviewView;
